export const titleForm = ({ nameLocal }) => {
	if (nameLocal) {
		return (
			<>
				{nameLocal}
				<span> (Nombre visible en web)</span>
			</>
		);
	}
};
